export default __webpack_public_path__ + "static/media/robert-katzki-jbtfM0XBeRc-unsplash.02668c9c.png";